/* Shopify cart bridge for the Zappycard and Zappystand PDPs.

   Fix: this file used to save button.textContent and wrote it
   back after the add, which flattened the button and deleted its
   [data-cta-label] span — after the first add, the label froze ("Add 5 Cards"
   while 10 was selected). This file only toggles disabled. */

(function () {
  'use strict';

  var root = document.querySelector('[data-buybox]');
  if (!root) return;

  var variantId = root.dataset.variantId;
  var buttons = document.querySelectorAll('.btn--cart, button.btn[data-cta-label]');

  function qty() {
    return Math.min(99, Math.max(1, parseInt(root.dataset.qty, 10) || 1));
  }

  function parse(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  /* Swap the whole of #CartDrawer, clear is-empty, rebind the overlay and
     refresh the header bubble's contents (not the anchor itself). */
  function showDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    var sections = data.sections || {};
    var fresh = sections['cart-drawer'] && parse(sections['cart-drawer'], '#CartDrawer');
    var live = drawer && drawer.querySelector('#CartDrawer');
    if (!drawer || !fresh || !live) return false;

    live.innerHTML = fresh.innerHTML;
    drawer.classList.remove('is-empty');
    drawer.querySelectorAll('.is-empty').forEach(function (el) {
      el.classList.remove('is-empty');
    });

    var overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parse(sections['cart-icon-bubble'], '.shopify-section');
      bubble.innerHTML = b ? b.innerHTML : sections['cart-icon-bubble'];
    }

    drawer.open();
    return true;
  }

  function add(button) {
    if (!variantId) return;
    button.disabled = true;

    var routes = window.routes || {};
    fetch(routes.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty() }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, body: j }; });
      })
      .then(function (res) {
        if (!res.ok || res.body.status) {
          throw new Error(res.body.description || res.body.message || 'Add to cart failed');
        }
        button.disabled = false;
        if (!window.__zcBridge && !showDrawer(res.body)) window.location.href = '/cart';
      })
      .catch(function (err) {
        button.disabled = false;
        window.alert(err.message);
      });
  }

  buttons.forEach(function (b) {
    b.addEventListener('click', function () { add(b); });
  });
})();
